'use client'

import { ReactNode } from 'react'

import MsalCustomProvider from '@/core/msal/MsalCustomProvider'

interface IConfigMsalContainerProps {
  children: ReactNode
}

const ConfigMsalContainer: React.FC<IConfigMsalContainerProps> = ({
  children,
}) => {
  return <MsalCustomProvider>{children}</MsalCustomProvider>
}

export default ConfigMsalContainer
